module.exports = __webpack_public_path__ + "static/img/zhanshi3.3d40eba0.png";